import { lighten, makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import { Tooltip, Button, Grid } from "@material-ui/core";
import ExcelFile from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";
import EditIcon from '@mui/icons-material/Edit';
import React, { useMemo } from "react";
import clsx from "clsx";
import useToggle from "../../../shared/functions/useToggle";
import POEdit from "./POEdit";
// import POList from "./POList";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';


import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
// import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';


export const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.primary.main,
                backgroundColor: lighten(theme.palette.primary.light, 0.85),
                border: 0,
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.primary.dark,
            },
    title: {
        flex: '1 1 50%',
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const EnhancedTableToolbar = ({ numSelected, selectedItem, data, Currency }) => {
    const classes = useToolbarStyles();

    const isSomeThingSelected = useMemo(() => numSelected > 0, [numSelected])
    const { open, handleClose, handleOpen } = useToggle({})
    // const { open: isCreateModalOpen, handleClose: handleOrderClose, handleOpen: handleOrderOpen } = useToggle()

    const handleEditClose = () => {
        handleClose()
    }

    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('sm');

    return (
        <>
            <Toolbar className={clsx(classes.root, { [classes.highlight]: numSelected > 0 })} hidden={!isSomeThingSelected}>
                <Grid container className={classes.title}>
                    <Grid>
                        <Button style={{ marginRight: 20 }}> {"Selected : " + numSelected} </Button>
                    </Grid>
                    <Grid>
                        <Tooltip title={'Edit Purchase'}>
                            <Button startIcon={<EditIcon />} style={{ backgroundColor: "green", color: "white", marginRight: 30 }} onClick={handleOpen}>
                                EDIT PO
                            </Button>
                        </Tooltip>
                        <ExcelFile
                            element={(
                                <Button style={{ backgroundColor: "green", color: "white", marginRight: 30 }}>
                                    Exporter en excel
                                </Button>
                            )}
                        >
                            <ExcelSheet data={selectedItem} name="Orders">
                                <ExcelColumn label="ProSoft Id" value="proSoftId" />
                                <ExcelColumn label="Barcode" value="barcode" />
                                <ExcelColumn label="Name" value="name" />
                                <ExcelColumn label="Price" value="price" />
                                <ExcelColumn label="Ordered Quantity" value="quantity" />
                                <ExcelColumn label="Shipped Quantity" value="shippedQuantity" />
                                <ExcelColumn label="Discount" value="discount" />
                                <ExcelColumn label="Amount" value="amount" />
                                <ExcelColumn label="Is Received" value="isReceived" />
                                <ExcelColumn label="Sell Price" value="sellPrice" />
                                <ExcelColumn label="Expires" value="expires" />
                            </ExcelSheet>
                        </ExcelFile>
                        {
                            Currency && Currency === "FCFA" ?
                            <ExcelFile
                                element={(
                                    <Button style={{backgroundColor: "green", color: "white"}}>
                                        Exporter tout en excel pour reception
                                    </Button>
                                )}
                            >
                                <ExcelSheet data={data} name="Orders">
                                    <ExcelColumn label="Code article" value="proSoftId"/>
                                    <ExcelColumn label="Référence" value=""/>
                                    <ExcelColumn label="Code Bare" value="barcode"/>
                                    <ExcelColumn label="Nom article" value="name"/>
                                    <ExcelColumn label="Description" value="name"/>
                                    <ExcelColumn label="Qté achat" value="quantity"/> 
                                    <ExcelColumn label="Prix achat" value="price"/> 
                                    <ExcelColumn label="Prix de vente" value="sellPrice"/>
                                    <ExcelColumn label="Pack" value="HasClilds"/>
                                    <ExcelColumn label="Classe" value="ClassItem"/>
                                    <ExcelColumn label="Seuil réaprovisionnement" value="Threshold"/>
                                    <ExcelColumn label="N° Lot" value="expires"/> 
                                    <ExcelColumn label="Date expiration" value="expires"/>
                                </ExcelSheet>
                            </ExcelFile> : <div></div>
                        }

                        {
                            open && (
                                <POEdit open={open} onClose={handleEditClose} data={selectedItem}/>

                                // <div>
                                //     <Dialog
                                //         fullScreen
                                //         open={open}
                                //         onClose={handleClose}
                                //         TransitionComponent={Transition}
                                //     >
                                //         <AppBar sx={{ position: 'relative' }}>
                                //             <Toolbar>
                                //                 <IconButton
                                //                     edge="start"
                                //                     color="inherit"
                                //                     onClick={handleClose}
                                //                     aria-label="close"
                                //                 >
                                //                     <CloseIcon />
                                //                 </IconButton>
                                //                 <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                //                     Sound
                                //                 </Typography>
                                //                 <Button autoFocus color="inherit" onClick={handleClose}>
                                //                     save
                                //                 </Button>
                                //             </Toolbar>
                                //         </AppBar>
                                //         <List>
                                //             <ListItem button>
                                //                 <ListItemText primary="Phone ringtone" secondary="Titania" />
                                //             </ListItem>
                                //             <Divider />
                                //             <ListItem button>
                                //                 <ListItemText
                                //                     primary="Default notification ringtone"
                                //                     secondary="Tethys"
                                //                 />
                                //             </ListItem>
                                //         </List>
                                //     </Dialog>
                                // </div>

                            )
                        }

                    </Grid>
                </Grid>
            </Toolbar>
        </>
    );
};
